import { render, staticRenderFns } from "./InvestorRelationsLayout.vue?vue&type=template&id=4e8b4e5a"
import script from "./InvestorRelationsLayout.vue?vue&type=script&lang=js"
export * from "./InvestorRelationsLayout.vue?vue&type=script&lang=js"
import style0 from "./InvestorRelationsLayout.vue?vue&type=style&index=0&id=4e8b4e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports